// extracted by mini-css-extract-plugin
export var externalLink = "_cm-0";
export var internalLinkLabel = "_cm-1";